export const GMAT_SET_MOCK_SHOP = "GMAT_SET_MOCK_SHOP";
